//
// GENERATED by KVision
//
package pl.finn.forms.teryt

import org.w3c.fetch.RequestInit
import io.kvision.remote.KVRemoteAgent
import kotlinx.serialization.modules.SerializersModule
import pl.finn.forms.teryt.AddressList
import pl.finn.forms.teryt.CommunityList
import pl.finn.forms.teryt.CountyList
import pl.finn.forms.teryt.LocalityList
import pl.finn.forms.teryt.StreetList
import pl.finn.forms.teryt.VoivodeshipList

actual class TerytApiService(serializersModules: List<SerializersModule>? = null, requestFilter: (suspend RequestInit.() -> Unit)? = null) : ITerytApiService, KVRemoteAgent<TerytApiService>(TerytApiServiceManager, serializersModules, requestFilter) {
    override suspend fun addresses(postalCode: String?) = call(ITerytApiService::addresses, postalCode)
    override suspend fun voivodeships() = call(ITerytApiService::voivodeships)
    override suspend fun countries(voivodeship: String?) = call(ITerytApiService::countries, voivodeship)
    override suspend fun communities(county: String?) = call(ITerytApiService::communities, county)
    override suspend fun localities(community: String?) = call(ITerytApiService::localities, community)
    override suspend fun streets(locality: String?, page: Int?) = call(ITerytApiService::streets, locality, page)
}
